(() => {
  if (new URLSearchParams(location.search).get('sova_search_debug') !== '1') return;
  if (document.getElementById('sova-search-debug')) return;
  const records = [];
  const panel = document.createElement('div');
  panel.id = 'sova-search-debug';
  panel.style.cssText = 'position:fixed;bottom:60px;left:8px;right:8px;z-index:2147483647;background:#fff;color:#13423c;border:2px solid #13423c;border-radius:8px;padding:8px;font:12px/1.35 monospace;max-height:42vh;overflow:auto';
  const summary = document.createElement('button');
  summary.type = 'button';
  summary.textContent = 'SOVABOOKS: диагностика поиска';
  summary.setAttribute('aria-expanded', 'false');
  const content = document.createElement('div');
  content.hidden = true;
  summary.addEventListener('click', () => {
    content.hidden = !content.hidden;
    summary.setAttribute('aria-expanded', String(!content.hidden));
  });
  const copy = document.createElement('button');
  copy.type = 'button';
  copy.textContent = 'Скопировать диагностику';
  const output = document.createElement('textarea');
  output.readOnly = true;
  output.setAttribute('aria-label', 'Диагностика поиска');
  output.style.cssText = 'display:block;width:100%;height:180px;font:11px/1.3 monospace;color:#13423c;background:#fff';
  content.append(copy, output);
  panel.append(summary, content);
  document.body.append(panel);
  const activeInput = () => {
    const mobile = document.getElementById('snize-mobile-search-input');
    if (mobile && mobile.getClientRects().length) return mobile.value;
    const active = document.activeElement;
    return active && active.matches('input[name="q"]') ? active.value : null;
  };
  const record = (type, data = {}) => {
    records.push({time: new Date().toISOString(), type, ...data});
    if (records.length > 100) records.shift();
    output.value = JSON.stringify(records, null, 2);
    summary.textContent = 'SOVABOOKS: диагностика поиска (' + records.length + ')';
  };
  copy.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(output.value);
      copy.textContent = 'Скопировано';
    } catch {
      output.focus();
      output.select();
      copy.textContent = 'Выделено: скопируйте текст';
    }
  });
  const isSearch = target => target instanceof HTMLInputElement && (target.id === 'snize-mobile-search-input' || target.name === 'q');
  for (const type of ['input', 'change', 'compositionend', 'search']) {
    document.addEventListener(type, event => {
      if (isSearch(event.target)) record(type, {input: event.target.value, inputId: event.target.id, composing: Boolean(event.isComposing)});
    }, true);
  }
  let attempts = 0;
  const bind = () => {
    if (!window.Searchanise || !window.Searchanise.$) return false;
    const jq = window.Searchanise.$;
    jq(document).on('Searchanise.DataRequestBefore.sovaDebug', (_event, type, params) => {
      if (type !== 'autocomplete') return;
      record('request', {input: activeInput(), q: params.q, filter: params.restrictBy, language: params.translationLanguage, maxResults: params.maxResults});
    });
    jq(document).on('Searchanise.DataRequestEnd.sovaDebug', (_event, type, params, data) => {
      if (type !== 'autocomplete') return;
      record('response', {input: activeInput(), q: params.q, corrected: data.correctedQuery, total: data.totalItems, titles: (data.items || []).map(item => item.title)});
    });
    record('ready');
    return true;
  };
  record('start', {viewport: innerWidth, language: document.documentElement.lang});
  if (!bind()) {
    const timer = setInterval(() => {
      attempts += 1;
      if (bind() || attempts >= 80) clearInterval(timer);
    }, 250);
  }
})();
